module.exports = __webpack_public_path__ + "static/img/shooting03.76eb717.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/works/photographing/shooting03.jpg
// module id = FGwU
// module chunks = 0